import {widgetFromDomaintypeGenerator} from "../../../misc/widget-functions"
import Content from "../../../components/Content"
import React, {useMemo} from "react"

const Question = ({question}) => {
    const displayQuestions = question.children?.length ? question.children : [question]
    const displayWidgets = useMemo(
        () => displayQuestions.map(question => widgetFromDomaintypeGenerator(question, question.pointer)),
        [displayQuestions],
    )
    return displayWidgets.map(widget => <Content key={widget.id} child={widget} />)
}

export default Question
